import { motion } from "framer-motion";
import { MapPin, Heart } from "@phosphor-icons/react";
import Reveal from "@/components/site/Reveal";

export default function MeetTheAndersons() {
  return (
    <section id="team" data-testid="team-section" className="relative py-24 lg:py-32 bg-ink overflow-hidden">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid lg:grid-cols-5 gap-12 lg:gap-16 items-center">
          <Reveal className="lg:col-span-2">
            <div className="relative">
              <div className="absolute -inset-3 border border-line" aria-hidden="true" />
              <div className="relative overflow-hidden">
                <motion.img
                  initial={{ scale: 1.12 }}
                  whileInView={{ scale: 1 }}
                  viewport={{ once: true }}
                  transition={{ duration: 1.4, ease: [0.22, 1, 0.36, 1] }}
                  src="/team-anderson.jpg"
                  alt="Blake and Brittnie Anderson with their two children"
                  className="w-full object-cover aspect-[4/5]"
                />
              </div>
              <div className="absolute -bottom-4 -right-4 bg-gold text-ink px-5 py-3 flex items-center gap-2">
                <Heart weight="fill" size={18} />
                <span className="font-heading font-semibold text-sm">Family owned &amp; local</span>
              </div>
            </div>
          </Reveal>

          <div className="lg:col-span-3">
            <Reveal>
              <p className="text-xs uppercase tracking-[0.3em] text-gold mb-5">About Us</p>
            </Reveal>
            <Reveal delay={0.05}>
              <h2 className="font-heading font-bold tracking-tight text-white text-4xl sm:text-5xl leading-[1.05]">
                Meet the Andersons
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <div className="mt-7 space-y-5 text-base sm:text-lg text-white/70 leading-relaxed">
                <p>
                  <span className="text-white font-semibold">Blake</span> is a longtime Schertz
                  resident who grew up here and has deep roots in the local community. With years of
                  hands-on experience in home repairs, remodeling, and general handyman services, Blake is
                  dedicated to helping homeowners in Schertz, Cibolo, New Braunfels, and surrounding areas
                  maintain and improve their homes.
                </p>
                <p>
                  <span className="text-white font-semibold">Brittnie</span> is a Licensed Nurse working in
                  home health with an extensive background in geriatric care management.
                </p>
                <p>
                  As a proud husband and father of two, Blake understands the value of a safe, functional,
                  and beautiful home. His commitment to quality, honesty, and reliability has made B3
                  Contracting a trusted name for both small repairs and large-scale projects, including
                  complete remodels and roofing.
                </p>
                <p>
                  Blake loves serving the community that shaped him and takes pride in treating every
                  project, big or small, as if it were his own home. Whether it's a quick repair, a major
                  renovation, or anything in between, Blake and the B3 team — named before little
                  B #4 came along — are ready to get it done right.
                </p>
              </div>
            </Reveal>
            <Reveal delay={0.15}>
              <div className="mt-8 flex items-center gap-2 text-sm text-gold">
                <MapPin weight="fill" size={16} />
                Proudly based in Schertz, Texas
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
